import request from '@/utils/request'

const baseUrl = '/erp/sales/report/purchase-reference-summary'

export const pagePurchaseReferenceSummaryReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const listPurchaseReferenceSummarySupplierOptions = () => request({
  url: baseUrl + '/supplier-options',
  method: 'get'
})

export const exportPurchaseReferenceSummaryReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
